import React from "react";
import { Outlet } from "react-router-dom";
import "./AnimeHubLayout.css";

const AnimeHubLayout = () => {
  return (
    <div className="AnimeHubLayout">
      <Outlet />
    </div>
  );
};

export default AnimeHubLayout;
